import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowExportIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 13C21.45 13 21 13.45 21 14V22H3V14C3 13.45 2.55 13 2 13C1.45 13 1 13.45 1 14V22C1 23.1 1.9 24 3 24H21C22.1 24 23 23.1 23 22V14C23 13.45 22.55 13 22 13Z"
        fill={color}
      />
      <path
        d="M6.71001 7.71L11 3.42V18.01C11 18.56 11.45 19.01 12 19.01C12.55 19.01 13 18.56 13 18.01V3.41L17.29 7.7C17.68 8.09 18.31 8.09 18.7 7.7C19.09 7.31 19.09 6.68 18.7 6.29L12.71 0.289999C12.32 -0.100001 11.69 -0.100001 11.3 0.289999L5.30001 6.29C4.91001 6.68 4.91001 7.31 5.30001 7.7C5.69001 8.09 6.32001 8.09 6.71001 7.7V7.71Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowExportIcon.displayName = 'ArrowExportIcon';
